"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_72_0_0 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const produktbereichtypToCategoryMapping = {
    10: echain_shared_articles_1.LeitungCategory.ControlCables,
    20: echain_shared_articles_1.LeitungCategory.DataCables,
    30: echain_shared_articles_1.LeitungCategory.MotorCables,
    40: echain_shared_articles_1.LeitungCategory.SpecialCables,
    170: echain_shared_articles_1.LeitungCategory.SpecialCables,
    50: echain_shared_articles_1.LeitungCategory.CoaxCables,
    60: echain_shared_articles_1.LeitungCategory.ServoCables,
    70: echain_shared_articles_1.LeitungCategory.PneumaticHoses,
    110: echain_shared_articles_1.LeitungCategory.RobotCables,
    120: echain_shared_articles_1.LeitungCategory.FibreOpticCables,
    130: echain_shared_articles_1.LeitungCategory.DataCables,
    140: echain_shared_articles_1.LeitungCategory.MeasuringSystemCables,
    150: echain_shared_articles_1.LeitungCategory.BusCables,
};
/**
 * Migrate to 72.0.0
 *
 * map produktbereichTypen of LeitungFilterProperties to LeitungCategory
 *
 * delete ProduktbereichTyp on each Leitung
 * delete Leitungstyp on each Leitung
 *
 */
const migration_72_0_0 = (json) => {
    var _a;
    const oldLeitungFilterProperties = json.LeitungFilterProperties;
    const oldProduktbereichtyp = ((_a = oldLeitungFilterProperties === null || oldLeitungFilterProperties === void 0 ? void 0 : oldLeitungFilterProperties.produktbereichTypen) === null || _a === void 0 ? void 0 : _a[0]) || undefined;
    if (oldProduktbereichtyp) {
        delete oldLeitungFilterProperties.produktbereichTypen;
        const newCategory = produktbereichtypToCategoryMapping[oldProduktbereichtyp] ||
            undefined;
        if (newCategory) {
            json.LeitungFilterProperties = Object.assign({ category: newCategory }, oldLeitungFilterProperties);
        }
    }
    if (json.Leitungen) {
        json.Leitungen.forEach((leitungJson) => {
            delete leitungJson.ProduktbereichTyp;
            delete leitungJson.Leitungstyp;
        });
    }
    return json;
};
exports.migration_72_0_0 = migration_72_0_0;
//# sourceMappingURL=migration_72_0_0.js.map